const PAGINATION_CONTROL_SELECTOR = [
  ".ant-pagination-item",
  ".ant-pagination-prev",
  ".ant-pagination-next",
  ".ant-pagination-jump-prev",
  ".ant-pagination-jump-next",
].join(",");

const OVERLAY_SCROLL_CONTAINER_SELECTOR = ".ant-modal-body, .ant-drawer-body";

const toPositiveNumber = (value, fallback) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) && parsedValue > 0
    ? parsedValue
    : fallback;
};

export const getTableRowNumber = (rowIndex, pagination = {}) => {
  const currentPage = toPositiveNumber(
    pagination.current_page ?? pagination.current ?? pagination.currentPage,
    1,
  );
  const pageSize = toPositiveNumber(
    pagination.per_page ?? pagination.pageSize ?? pagination.perPageSize,
    10,
  );
  const normalizedIndex = Math.max(0, Number(rowIndex) || 0);

  return (currentPage - 1) * pageSize + normalizedIndex + 1;
};

const scrollToTop = (paginationElement, ownerWindow) => {
  const overlayContainer = paginationElement.closest(
    OVERLAY_SCROLL_CONTAINER_SELECTOR,
  );

  if (overlayContainer) {
    if (typeof overlayContainer.scrollTo === "function") {
      overlayContainer.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      overlayContainer.scrollTop = 0;
    }
    return;
  }

  if (typeof ownerWindow.scrollTo === "function") {
    ownerWindow.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    ownerWindow.document.scrollingElement.scrollTop = 0;
  }
};

export const installPaginationScrollToTop = ({
  root = typeof document === "undefined" ? null : document,
} = {}) => {
  if (!root?.addEventListener) return () => {};

  const ownerWindow = root.defaultView || root.ownerDocument?.defaultView;
  if (!ownerWindow) return () => {};

  const elementConstructor = ownerWindow?.Element;
  const scheduleScroll =
    typeof ownerWindow.requestAnimationFrame === "function"
      ? ownerWindow.requestAnimationFrame.bind(ownerWindow)
      : (callback) => ownerWindow.setTimeout(callback, 0);

  const handlePaginationClick = (event) => {
    if (!elementConstructor || !(event.target instanceof elementConstructor)) {
      return;
    }

    const control = event.target.closest(PAGINATION_CONTROL_SELECTOR);
    if (
      !control ||
      control.classList.contains("ant-pagination-disabled") ||
      control.classList.contains("ant-pagination-item-active")
    ) {
      return;
    }

    const paginationElement = control.closest(".ant-pagination");
    if (!paginationElement) return;

    scheduleScroll(() => {
      scrollToTop(paginationElement, ownerWindow);
    });
  };

  root.addEventListener("click", handlePaginationClick, true);

  return () => {
    root.removeEventListener("click", handlePaginationClick, true);
  };
};
